<template>
    <div>
        <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
            <!-- SERIE -->
            <div class="field col-12 md:col-3">
                <span class="p-float-label">
                    <Dropdown v-model="cotizacion.serie" :options="itemsSerie" :editable="true" />
                    <label>Serie</label>
                </span>
            </div>
            <!-- FOLIO -->
            <div class="field col-12 md:col-3">
                <span class="p-float-label">
                    <InputText v-model="cotizacion.folio" type="text" />
                    <label>Folio</label>
                </span>
            </div>
            <!-- FECHA -->
            <div class="field col-12 md:col-3">
                <span class="p-float-label">
                    <Calendar v-model="cotizacion.fecha" dateFormat="dd-MM-yy" />
                    <label>Fecha</label>
                </span>
            </div>
            <!-- TIEMPO DE ENTREGA -->
            <div class="field col-12 md:col-3">
                <span class="p-float-label">
                    <Dropdown v-model="cotizacion.tiempoEntrega" :options="listaTiempoEntrega" />
                    <label>Tiempo de Entrega</label>
                </span>
            </div>
            <div class="field col-12">
                <div class="p-inputgroup justify-center">
                    <span class="p-float-label">
                        <AutoComplete :forceSelection="true" style="text-align: left" v-model="cotizacion.solicitante"
                            :suggestions="filteredUsuario" @complete="searchUsuario($event)">
                        </AutoComplete>
                        <label>Solicitante</label>
                    </span>
                </div>
            </div>
            <!-- PROVEEDOR -->
            <div class=" field col-12">
                <div class="p-inputgroup">
                    <span class="p-float-label">
                        <AutoComplete style="text-align: left" v-model="cotizacion.proveedor" :suggestions="filtroProveedor"
                            @complete="searchProveedor($event)" field="proveedor">
                        </AutoComplete>
                        <label>Proveedor</label>
                    </span>
                </div>
            </div>
            <!-- PROYECTO -->
            <div class="field col-12">
                <span class="p-float-label">
                    <Dropdown v-model="cotizacion.proyecto" optionLabel="descripcion" :options="itemsProyectos" />
                    <label>Proyecto</label>
                </span>
            </div>
            <!-- NOTAS -->
            <div class="field col-12 md:col-12">
                <span class="p-float-label">
                    <InputText v-model="cotizacion.notas" type="text" />
                    <label>Notas</label>
                </span>
            </div>

        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    components: {
    },

    data() {
        return {
            filtroProveedor: null,
            filteredUsuario: null,
            listaUsuarios: [],
            listaTiempoEntrega: ['1 Dia', '3 - 5 Dias', '1 Semana', '15 Dias', '1 Mes', 'Más de un Mes']
        }
    },
    computed: {
        token() {
            return this.$store.state.usuario;
        },
        cotizacion() {
            return this.$store.state.comprasCotizacionStore
        },
        itemsSerie() {
            return this.$store.state.listComprasCotizacionSerieStore;
        },
        proveedores() {
            return this.$store.state.listaProveedorStore;
        },
        itemsProyectos() {
            return this.$store.state.listProyectosStore.filter(x => x.estatus == 'Vigente');;
        },
    },
    created() {
        this.getUsuarios()
    },
    methods: {
        searchProveedor(event) {
            setTimeout(() => {
                if (!event.query.trim().length) {
                    this.filtroProveedor = [...this.proveedores];
                }
                else {
                    this.filtroProveedor = this.proveedores.filter((country) => {
                        return country.proveedor.toLowerCase().includes(event.query.toLowerCase());
                    });
                }
            }, 250);
        },
        searchUsuario(event) {
            setTimeout(() => {
                if (!event.query.trim().length) {
                    this.filteredUsuario = [...this.listaUsuarios];
                }
                else {
                    this.filteredUsuario = this.listaUsuarios.filter((country) => {
                        return country.toLowerCase().includes(event.query.toLowerCase());
                    });
                }
            }, 250);
        },
        async getUsuarios() {
            try {
                let response = await axios.get('Usuarios/GetUsuariosCompras/' + this.token.empresaBase)
                this.listaUsuarios = response.data
                console.log(response)

            } catch (error) {
                console.log(error)
            }
        },
    },
}
</script>